<template>
  <div>
    <div class="d-flex">
      <p class="page-title my-auto"><slot name="title"></slot></p>
      <div class="ml-auto my-auto"><slot name="action"></slot></div>
    </div>
    <div class="mt-4">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import Navbar from "components/Navbar.vue";

@Component({ components: { Navbar } })
export default class Page extends Vue {}
</script>

<style lang="scss" scoped></style>
